import React, { useState } from 'react'
import moment from 'moment'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { Panel, IconButton, FlexboxGrid, Checkbox, Timeline, Icon, Modal, ButtonToolbar, InputGroup, Input } from 'rsuite'
import { DeleteModal, Summary } from './EventComponents'
import { TitlePlus, SmallText, PinkSpan, StartButton, NormalText } from './MyEventStyledComponents'
import { colors, fonts } from '../Styles/common-styles'
import { ArrowDown, ArrowUp, Bin } from '../Icons'
import styled from 'styled-components'
// import { getActivities } from '../../Context/prismic'

const styles = {
  buttonStyle: {
    position: 'relative',
    zIndex: '5',
    width: 'auto',
    '&:hover': {
      background: colors.purpleBright
    }
  },
  iconButton: {
    background: colors.white,
    display: 'flex'
  },

  panel: {
    background: colors.white,
    margin: '1.5% auto',
    minHeight: '107px',
    width: '100%',
    border: `1px solid ${colors.stroke}`
  },
  eventTitle: {
    width: '331px',
    height: '51px',
    left: '39px'
  }
}

const TextField = styled.div`
  font-size: fonts.normalSize;
`
const GoalList = styled.li`
    font-size:${fonts.normalSize}
    ::before, ::marker {
    content: '...'!important;
    line-height: 140%;
    padding:5px;
}
`
const GoalTitle = styled.div`
    font-size:${fonts.largeSize};
    padding: 5px;
    list-style: none;
    left: 0px;
    font-weight: 600;
}
`

export default function Event (props) {
  const fullEvent = props
  // const [loading, setLoading] = useState(true)
  const [isClicked, setClicked] = useState(false)
  const [showModal, setModalShown] = useState(false)
  const [ShowStartModal, setStartModalShown] = useState(false)

  // const { phases } = props
  const d = moment(props.date).format('DD MMM YYYY, HH:mm')

  // Function to show and hide delete modal
  const showDeleteModal = () => { setModalShown(true) }
  const hideDeleteModal = () => { setModalShown(false) }

  const showStartModal = () => { setStartModalShown(true) }
  const hideStartModal = () => { setStartModalShown(false) }

  const handleModalDelete = (e) => {
    props.handleDelete(e)
    setModalShown(false)
  }
  const onClickStart = (eventId, e) => {
    window.open(window.location.href = `/events/${eventId}/`)
  }

  // function which returns an object of preparation and tools arrays
  const getToolsAndPreparation = () => {
    const prepArray = []
    const toolsArray = []
    const uniq = arr => [...new Set(arr)]
    fullEvent.phases.forEach(phase => {
      phase.data.forEach(activity => {
        activity?.preparation.forEach(prep => {
          prepArray.push(prep.text)
        })
        activity?.requisites.forEach(tools => {
          toolsArray.push(tools.text)
        })
      })
    })
    return { tools: uniq(toolsArray), prep: uniq(prepArray) }
  }

  return (
    <>
      <DeleteModal
        show={showModal}
        handleClose={hideDeleteModal}
        title={props.title}
        id={fullEvent.id}
        onDelete={() => handleModalDelete}
        msg='Event' />
      <StartModal
        show={ShowStartModal}
        handleClose={hideStartModal}
        onStart={onClickStart.bind(null, fullEvent.id)}
        link={`${window.location.origin}/event/${fullEvent.id}/participant`}
      />
      <Panel
        className='event-panel'
        style={styles.panel}
        header={
          <div style={{ display: 'inline-flex', justifyContent: 'space-evenly', alignItems: 'center', width: '100%' }}>
            <FlexboxGrid.Item
              onClick={e => { window.location.href = `/events/${fullEvent.id}/event` }}
              colspan={19}
              style={{ display: 'inline-flex', justifyContent: 'center' }}
            >
              <div style={{ width: '50%' }}>
                <SmallText style={{ color: colors.pink, fontSize: 'fonts.smallSize' }}>{d}</SmallText>
                <TitlePlus>{props.title}</TitlePlus>
              </div>
              <div style={{ width: '50%', justifySelf: 'center', margin: '2%' }}>
                <Summary large {...fullEvent} />
                {/* {
                  !fullEvent
                    ? <>
                      <Summary large {...fullEvent} />
                    </>
                    : <Loader />
                } */}
              </div>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item colspan={5} sm={24} style={{ display: 'inline-flex', justifyContent: 'flex-end' }}>
              <IconButton
                style={styles.iconButton}
                icon={<Bin stroke={colors.pink} />}
                onClick={showDeleteModal}
              />
              <StartButton style={styles.button} onClick={showStartModal}>Start</StartButton>
              <IconButton
                onClick={() => setClicked(!isClicked)}
                style={styles.iconButton}
                icon={isClicked ? <ArrowUp stroke={colors.pink} /> : <ArrowDown stroke={colors.pink} />} />
            </FlexboxGrid.Item>
          </div>
        }>
        {!isClicked
          ? null
          : (<div style={{ display: 'inline-flex', justifyContent: 'center', margin: '1%' }}>
            <FlexboxGrid.Item colspan={8}>
              <TextField>Goals:</TextField>
              {/* <div style={{ fontSize: 'fonts.smallSize', margin: ' 1%' }}>
                <br />{fullEvent.goalsArray.map((event, i) => <li className='' key={i}>{event.goals}</li>)}
              </div> */}
              {!fullEvent.goalsArray
                ? fullEvent.goals.map((event, i) => <li className='' key={i}>{event}</li>)
                : <GoalsList event={fullEvent.goalsArray} />}
            </FlexboxGrid.Item>
            <FlexboxGrid.Item colspan={6} style={{ fontSize: 'fonts.normalSize' }}><PinkSpan />
              <div>Structure:</div>
              <Timeline>
                {fullEvent?.phases?.map((event, i) => <TimelineEvent key={i} {...event} />)}
              </Timeline>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item colspan={5} style={{ fontSize: 'fonts.normalSize' }}><PinkSpan />
              <div>Preparation:</div>
              <div>
                {getToolsAndPreparation().prep.map(
                  (item, index) => (
                    <Checkbox key={index}>{item}</Checkbox>
                  )
                )}
              </div>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item colspan={5} style={{ fontSize: 'fonts.normalSize' }}><PinkSpan />
              <div>Tools:</div>
              <div>
                {getToolsAndPreparation().tools.map(
                  (item, index) => (
                    <Checkbox key={index}>{item}</Checkbox>
                  )
                )}
              </div>
            </FlexboxGrid.Item>
          </div>)}
      </Panel>
    </>
  )
}

const TimelineEvent = ({ name, data }) => {
  return (
    <Timeline.Item dot={<Icon className='customDot' icon='' />}>
      <p>{name}</p>
      {data.map((activity, i) => <p key={i}>{!activity ? null : activity.title && activity.title[0].text}</p>)}
    </Timeline.Item>
  )
}

const GoalsList = ({ event }) => {
  const array = []
  event.map((item) => array.push(item.title))
  const titles = Array.from(new Set(array))
  return (
    <>
      {titles.map((item, i) => {
        return (
          <React.Fragment key={i}>
            <GoalTitle key={i}>{item}</GoalTitle>
            {event.map((event, index) => {
              if (event.title.includes(item)) {
                return (
                  <GoalList className='goal' key={index}>{event.goals}</GoalList>
                )
              }
            })}
          </React.Fragment>
        )
      })}
    </>
  )
}

const StartModal = (props) => {
  const [isCopied, setCopied] = useState(false)
  return (
    <Modal
      className='deleteModal'
      show={props.show}
      onHide={props.handleClose}
      style={{ width: '450px', margin: 'auto' }}
    >
      <Modal.Header />
      <Modal.Body>
        <TitlePlus style={{ paddingBottom: '3%' }} centered>Share it with your audience</TitlePlus>
        <NormalText style={{ fontSize: fonts.largeSize, paddingBottom: '3%' }} greyed>Separate participant view will mirror the entire event flow, but with necessary content only. </NormalText>
        <NormalText>Copy Link</NormalText>
        <InputGroup>
          <Input
            value={props.link}
            style={{ width: '100%', position: 'relative', zIndex: '1', height: '40px' }} />
          {!isCopied
            ? <CopyToClipboard
              text={props.link}
            >
              <StartButton
                style={{ height: '27px', margin: 'auto', ...styles.buttonStyle }}
                onClick={() => setCopied(true)}
              >
                Copy
              </StartButton>
            </CopyToClipboard>

            : <StartButton
              style={{ backgroundColor: colors.pink, height: '30px', margin: 'auto' }}
              appearance='primary'>
              Copied </StartButton>}
        </InputGroup>
        <NormalText
          style={{ paddingTop: '15px' }}
          onClick={() => { window.open(props.link, '_blank', 'width=980,height=780') }}>
          Or <span
            style={{ color: colors.purpleMain, textDecoration: 'underline', textDecorationColor: colors.purpleMain, justifyContent: 'center' }}>
            open in a new window</span>
        </NormalText>
      </Modal.Body>
      <Modal.Footer>
        <ButtonToolbar style={{ textAlign: 'center', padding: '5%' }}>
          <StartButton
            onClick={props.onStart}
            style={styles.buttonStyle}
            value={props.id}>
            Start event
          </StartButton>
        </ButtonToolbar>
      </Modal.Footer>
    </Modal>
  )
}
